import get from 'lodash/get';
import React from 'react';
import MaskedInput from 'react-text-mask';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';


type PropType = {
    type: string;
    className?: string;
    name: string;
    label?: string;
    label1?: string;
    placeholder?: string;
    value?: any;
    mask?: any;
    guide?: boolean;
    withError?: boolean;
    disabled?: boolean;
    addorn?: any;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
};

const RadioNumberField = (props: PropType) => (
    <AppContext.Consumer>
        {({ theme, locale }) => (
            <InputWrapper
                theme={theme}
                className={`form-input-wrapper_${props.name} ${props.className || ''}`}
            >
                {I18n.l(props.label1 || '')}

                <MaskedInput
                    type={props.type}
                    style={{ width: '15%', height: '30px', marginTop: '30px', marginLeft: '5px' }}
                    mask={props.mask}
                    guide={props.guide || false}
                    className={`form-input_${props.name} ${props.className || ''}`}
                    name={props.name}
                    placeholder={I18n.l(props.placeholder || '')}
                    value={props.value}
                    disabled={props.disabled}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        props.setFieldValue(e.target.name, e.target.value);
                        props.setTouched({ [e.target.name]: true });
                    }}
                    render={(ref: any, maskedFieldProps: any) => (
                        <Input theme={theme} innerRef={ref} {...maskedFieldProps} type="text" />
                    )}
                />

            </InputWrapper>
        )}
    </AppContext.Consumer>
);

const InputWrapper = styled.div`
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }
`;

const Input = styled.input`
  background: #fff;
  border-size: 15px;
  flex: 1;
  ${({ theme }) => get(theme, 'form.inputnumber')};

  &.search {
    ${({ theme }) => get(theme, 'form.search')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.auth')};
  }
`;

const Addorn = styled.span`
  flex: 0;
  padding: 6px 4px;
  text-align: center;

  &:first-of-type {
    ${({ theme }) => get(theme, 'form.addornLeft')};
    padding-right: 0;
  }
  &:last-of-type {
    ${({ theme }) => get(theme, 'form.addornRight')};
    padding-left: 0;
  }
  &.disabled {
    background: #f2f2f2;
    color: #888;
  }
`;

export default RadioNumberField;
